<template>
  <div :px="false">
    <template v-if="loading">
      <h1 class="font-semibold text-2xl mb-2">
        Loading...
      </h1>
    </template>

    <template v-else>
      <hero cover="cover" />
      <div>
        <h1 class="font-semibold text-2xl mb-2">
          {{ product && product.name }}
        </h1>
        <p>{{ product && product.description }}</p>
        <p>
          <label>Quantity </label>
          <input
            type="number"
            v-model="quantity"
            title="Add to room bill"
          /></p>
        <p>€ {{ product.price * quantity }}</p>
        <Button
          title="Add to room bill"
          v-on:click.native="addToRoomBill"
        />
      </div>
    </template>
  </div>
</template>

<script>
import Button from '@/components/partials/Button.vue'
// import Container from '@/components/container/Container'
import Hero from '@/sections/section-header/SectionHeader'
import MeService from '@/services/MeService'
import HttpError from '@/objects/Exceptions/HttpError'
import UpsellService from '@/services/UpsellService'
import BaseError from '@/objects/Exceptions/BaseError'

export default {
  name: 'UpsellProduct',
  components: {
    Button,
    // Container,
    Hero
  },
  data() {
    return {
      product: {
        name: '',
        price: '',
        imageUrl: '',
        alt: ''
      },
      quantity: 1
    }
  },
  computed: {
    loading () {
      return this.$store.state.upsell.loading
    },
    cover () {
      return {
        url: this.product && this.product.imageUrl || 'https://img.static-rmg.be/a/view/q75/w960/h520/2168532/english-breakfast-wat-komt-er-op-tafel.jpg',
        alt: this.product && this.product.alt || 'Beautiful breakfast'
      }
    }
  },
  mounted () {
    this.getUpsellProduct()
  },
  methods: {
    addToRoomBill () {
      const payload = {
        serviceId: this.$route.params.serviceId,
        externalId: this.$route.params.id,
        quantity: this.quantity
      }
      UpsellService.orderUpsellProduct(payload)
        .then((response) => {
          throw new BaseError({type: 'success', title: 'Thank you for your purchase', message: 'Your order id is ' + response.OrderId})

        }).catch((error) => {
          throw new BaseError({type: 'error', title: 'An error has occurred', message: error})
      })
    },
    getUpsellProduct () {
      const payload = {
        serviceId: this.$route.params.serviceId,
        externalId: this.$route.params.id
      }

      UpsellService.getUpsellProduct(payload)
        .then((response) => {
          if (response.status == 'failed') {
            throw HttpError.parseError(response.message)
          } else {
            this.product = response.product
          }
        }).catch((error) => {
          throw new BaseError({type: 'error', title: 'An error has occured', message: error})
      })
    }
  }
}
</script>
